export default __webpack_public_path__ + "static/media/violent-wind.dc3749f7.svg";